import React from 'react';

interface TrialLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubscribe: () => void;
}

const TrialLimitModal: React.FC<TrialLimitModalProps> = ({ isOpen, onClose, onSubscribe }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full max-w-md overflow-hidden rounded-3xl bg-gradient-to-br from-emerald-500 via-green-500 to-lime-400 p-[1px] shadow-2xl shadow-emerald-900/30">
        <div className="rounded-3xl bg-white/95 overflow-hidden">
          <div className="relative px-7 pt-7 pb-5 text-center">
            <div className="absolute -top-16 left-1/2 h-32 w-32 -translate-x-1/2 rounded-full bg-lime-300/40 blur-2xl" />
            <div className="relative mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-emerald-500 to-lime-400 shadow-lg shadow-emerald-500/30">
              <svg className="h-9 w-9 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
            <p className="relative text-xs font-bold uppercase tracking-[0.25em] text-emerald-700">STATDOG Pointer</p>
            <h2 className="relative mt-2 text-2xl font-extrabold text-gray-950">Your trial games are ready</h2>
          </div>

          <div className="px-7 pb-7 text-center">
            <div className="rounded-2xl bg-emerald-50/80 px-5 py-4">
              <p className="text-base leading-relaxed text-gray-800">
                You have added your three free trial games. You can start tracking stats now!
              </p>
              <p className="mt-3 text-base leading-relaxed text-gray-800">
                To add more games, please subscribe to STATDOG today.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={onSubscribe}
                className="rounded-xl bg-gradient-to-r from-emerald-600 to-green-500 px-5 py-3 font-bold text-white shadow-lg shadow-emerald-600/25 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-emerald-600/30"
              >
                Subscribe
              </button>
              <button
                type="button"
                onClick={onClose}
                className="rounded-xl bg-gray-100 px-5 py-3 font-bold text-gray-800 transition-all hover:bg-gray-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialLimitModal;
